const boldDigits: { [key: string]: string } = {
  '0': '𝟬',
  '1': '𝟭',
  '2': '𝟮',
  '3': '𝟯',
  '4': '𝟰',
  '5': '𝟱',
  '6': '𝟲',
  '7': '𝟳',
  '8': '𝟴',
  '9': '𝟵',
};

const unboldDigits: { [key: string]: string } = {
  '𝟬': '0',
  '𝟭': '1',
  '𝟮': '2',
  '𝟯': '3',
  '𝟰': '4',
  '𝟱': '5',
  '𝟲': '6',
  '𝟳': '7',
  '𝟴': '8',
  '𝟵': '9',
};

export const replaceWithBold = (text: string): string =>
  text.replace(/\d/g, (d: string) => boldDigits[d] ?? d);

export const replaceWithNormal = (text: string): string =>
  text.replace(/[𝟬𝟭𝟮𝟯𝟰𝟱𝟲𝟳𝟴𝟵]/gu, (d: string) => unboldDigits[d] ?? d);
